/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself
const Vue = window.Vue;



var variations = [];
/* const variations = {{ variations | json_encode() | raw }};
 var variationIds = [];
 $(variations).each(function(key, val){
     variationIds.push(val.variationId)
 })*/

 $(document).on('change','.storehouse-variation-select', function() {
     var attributesFormat = [];
     $('.storehouse-variation-select').each(function(){
         var attributeId = $(this).data("attributeid");
         var attributeValueId = $(this).find(":selected").val();
         attributesFormat.push({'attributeId':parseInt(attributeId),'attributeValueId':parseInt(attributeValueId)});
     });
     var activeVariationId = getVariationId(attributesFormat);
     $('.warehouse-stock-item').removeClass('active');
     $(`.warehouse-stock-item[data-variationid="${ activeVariationId }"]`).addClass('active');
 });
 $(document).on('change','.variation-select .custom-select', function() {
    $('.storehouse-variation-select').val($(this).find(":selected").val()).change();
 });
 
function getVariationId(attributes){
     var selectedVariation = null;
     var foundLength = 0;
     var hasLength = attributes.length;
     $(variations).each(function(key, variationVal){
         foundLength = 0;
         if(JSON.stringify(variationVal.attributes) === JSON.stringify(attributes) || JSON.stringify(variationVal.attributes.reverse()) === JSON.stringify(attributes)){
             selectedVariation = variationVal;
         }


     });
     return selectedVariation.variationId;
}
/*
$(document).on('click','.open-warehouse-modal', function() {
    if($('.warehouses-wrap').length<=0){
         $(this).append('<i aria-hidden="true" class="fa fa-spin fa-circle-o-notch ml-2"></i>');
         var data = {
             "itemid": vueApp.$store.getters.currentItemVariation.item.id,
             "activeVariationId": vueApp.$store.getters.currentItemVariation.variation.id
         }
         $.ajax({
             type: "GET",
             url: "/rest/getStoreStock",
             data: data,
             dataType: "json",
             success:function(response){
                 variations = response.data.variationAttributes;
                $('.content-warehouses').html(response.data.data);
                //$('body').append(response.data.data);
                //$('.modal-warehouses').modal();
                //$('.open-warehouse-modal').find('i').remove();
             },
             error:function(error){
                 console.log(error);

             }
         })
     }
     else{
         $('.modal-warehouses').modal();
     }

})*/

window.addEventListener('load', function () {
  
    if($('.content-warehouses').length > 0){
        if($('.warehouses-wrap').length <= 0){
           // $(this).append('<i aria-hidden="true" class="fa fa-spin fa-circle-o-notch ml-2"></i>');
           var bundleVariations = [];
           if(vueApp.$store.getters.currentItemVariation.hasOwnProperty("bundleComponents")){
                $(vueApp.$store.getters.currentItemVariation.bundleComponents).each(function(){
                    bundleVariations.push(this.data.variation.id)
                })
           }
         
            var data = {
                "itemid": vueApp.$store.getters.currentItemVariation.item.id,
                "activeVariationId": vueApp.$store.getters.currentItemVariation.variation.id,
                "bundleVariations": bundleVariations
            }
            
            $.ajax({
                type: "GET",
                url: "/rest/getStoreStock",
                data: data,
                dataType: "json",
                success:function(response){
                    variations = response.data.variationAttributes;

                   $('.content-warehouses').html(response.data.data);
                   setAvailability(ceresStore.getters.currentItemVariation.variation.id, ceresStore.getters.currentItemVariation.variation.availabilityId);
                   if($('.isBundleItem').length > 0){
                        $('.warehouse-item').each(function(){
                            var hasNotStockVariation = false;
                            var $noStockElement = null;
                            $(this).find('.warehouse-stock-item').each(function(){
                                if(parseInt($(this).data('variationstock')) <= 0){
                                    hasNotStockVariation = true;
                                    $noStockElement = $(this);
                                }
                            });
                            if(hasNotStockVariation){
                                $noStockElement.addClass('active');
                            }else{
                                $(this).find('.warehouse-stock-item').first().addClass('active');
                            }
                        }); 
                   } 
                   //$('body').append(response.data.data);
                   //$('.modal-warehouses').modal();
                   //$('.open-warehouse-modal').find('i').remove();
                },
                error:function(error){
                    console.log(error);
   
                }
            })
        }
    }
})
document.addEventListener("onVariationChanged", function(variation){

    setAvailability(variation.detail.documents[0].data.variation.id, variation.detail.documents[0].data.variation.availabilityId);  
});
function setAvailability(variationId, availabilityid){
    let hasStoreAvailability = false;

    $(`.warehouse-stock-item[data-variationid="${variationId}"]`).each(function(){
        if(parseInt($(this).data('variationstock')) > 0){
            hasStoreAvailability = true;
        }
    })
    var $customAvailbilityElement = $('.custom-availability');
    var availabilityTxt = $customAvailbilityElement.data('availability1');
    var availabilityClass = 'availability-1';
    /*if(availabilityid <= 4 && hasStoreAvailability){
        //Online und im Store Verfügbar
        availabilityTxt = $customAvailbilityElement.data('availability1')
    }*/
    if(availabilityid > 2 && hasStoreAvailability){
        //Online nicht da aber im Store Verfügbar
        availabilityTxt = $customAvailbilityElement.data('availability2');
        availabilityClass = 'availability-3';
    }
    if(availabilityid > 2 && !hasStoreAvailability){
        //Überhaupt nicht da
        availabilityTxt = $customAvailbilityElement.data('availability3');
        availabilityClass = 'availability-5';
    }
    $customAvailbilityElement.removeClass('availability-load').removeClass('availability-1').removeClass('availability-3').removeClass('availability-5').addClass(availabilityClass);
    $customAvailbilityElement.find('span').removeClass('invisible').html(availabilityTxt);
    
}